import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from "./components/Login";
import Bienvenida from "./components/Bienvenida";
import Calendario from "./components/Calendario";
import Captura from "./components/Captura";
import GraficaProyeccion from "./components/GraficaProyeccion";
import Configuracion from "./components/Configuracion";

import { PagosProvider } from "./state/PagosContext";
import Header from "./components/Header";
import { clearSession, getToken, getUser } from "./api";

export default function App() {
  const [session, setSession] = useState(() => {
    const token = getToken();
    const user = getUser();
    return token && user ? { token, user } : null;
  });

  useEffect(() => {
    // sesión persistida ya se maneja en localStorage desde api.js
  }, []);

  const handleLogin = (user) => {
    const token = getToken();
    setSession({ token, user });
  };

  const handleLogout = () => {
    clearSession();
    setSession(null);
  };

  const isAuthed = !!session;
  const role = session?.user?.role || '';
  const canCaptura = role === 'admin' || role === 'captura';

  return (
    <BrowserRouter>
      <PagosProvider session={session}>
        {isAuthed && <Header onLogout={handleLogout} user={session.user} />}

        <Routes>
          <Route
            path="/"
            element={isAuthed ? <Navigate to="/bienvenida" replace /> : <Login onLogin={handleLogin} />}
          />

          <Route path="/bienvenida" element={isAuthed ? <Bienvenida /> : <Navigate to="/" replace />} />
          <Route path="/calendario" element={isAuthed ? <Calendario /> : <Navigate to="/" replace />} />
          <Route path="/captura" element={isAuthed ? (canCaptura ? <Captura /> : <Navigate to="/calendario" replace />) : <Navigate to="/" replace />} />
          <Route path="/grafica" element={isAuthed ? <GraficaProyeccion /> : <Navigate to="/" replace />} />
          <Route path="/configuracion" element={isAuthed ? <Configuracion /> : <Navigate to="/" replace />} />

          <Route path="*" element={<Navigate to={isAuthed ? "/bienvenida" : "/"} replace />} />
        </Routes>
      </PagosProvider>
    </BrowserRouter>
  );
}
